module.exports = __webpack_public_path__ + "static/media/48.da175553.jpg";